import {Component, OnInit, Output, EventEmitter, ElementRef, Input} from '@angular/core';
import {Http, Headers, ResponseOptions} from "@angular/http";
import {Cookie} from "ng2-cookies/ng2-cookies";
import { Router} from "@angular/router";
import {HttpAddress} from "../../service/httpaddress";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @Output() login = new EventEmitter<any>();
  @Input() mes ='';
  username:string;
  userpass:string;
  name:string;
  pass:string;
  is_login:boolean = false;
  is_clogin:number=0;
  is_name:boolean = false;
  is_pass:boolean = false;
  is_mail:boolean= false;


  username_f:string;
  name_f:string;
  tokenmail_f:string;
  mail_f:string;
  tokencode_f:string=null;
  code_f:string;
  newpass_f:string;
  pass_f:string;
  renewpass_f:string;
  repass_f:string;

  mailclick:string = "点击发送验证码";
  is_getmailfocus:boolean = false;
  is_alterok:boolean = false;
  ischange:string = "正在修改";
  private headers= new Headers({'Content-type':'application/json'});
  private options;
  private httpget = new HttpAddress();
  constructor(private http:Http,
    private router:Router,
              private element: ElementRef
  ) { }
  ngOnInit() {
  }
  ngDoCheck(){
    var bool = this.sendEmail();
    if(this.is_getmailfocus==true){
      if(bool==true){
        this.is_mail = true;
      }
    }
    this.element.nativeElement.querySelector("#login").style.height = window.innerHeight+'px';
    this.element.nativeElement.querySelector("#login").style.minHeight = '700px';
  }
  //测试邮件
  testmail(){
    if(this.is_mail==false){
      this.is_mail=true;
    }else{
      this.is_mail = false;
    }
  }
  //忘记密码
  forgetpassword(){
    this.is_login = true;
  }
  //返回登录
  rebackLogin(){
    this.is_login = false;
    this.mailclick= "点击发送验证码";
    this.is_mail = false;
    this.ischange = null;
    this.username_f = null;
    this.name_f = null;
    this.tokenmail_f = null;
    this.mail_f = null;
    this.code_f = null;
    this.tokencode_f = null;
    this.newpass_f=null;
    this.pass_f=null;
    this.renewpass_f=null;
    this.repass_f=null;
  }
  getmailFocus(){
    this.is_getmailfocus = true;
  }
  /***用户输入信息检测***@method--->blur**/
  isUsername(){//用户名
    if(this.username_f==null||this.username_f==""){
      this.name_f="✖ 不能为空";
      return false;
    }else{
      // this.name_f="✔";
      return true;
    }
  }
  sendEmail(){ //发送邮件
    var mailreg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
    if(this.tokenmail_f==null||this.tokenmail_f==""){
      this.mail_f="✖ 不能为空";
      this.is_mail = false;
      return false;
    }else if(!mailreg.test(this.tokenmail_f)){
      this.mail_f="✖ 格式错误";
      this.is_mail = false;
      return false;
    }else{
      // this.mail_f="✔";
      this.is_mail = true;
      return true;
    }
  }
  isTokencode(){//验证码
    if(this.tokencode_f==null||this.tokencode_f==undefined||this.tokencode_f==""){
      this.code_f="✖ 不能为空";
      return false;
    }else{
      this.code_f="✔";
      return true;
    }
  }
  isNewpass(){//新密码
    if(this.newpass_f==null){
      this.pass_f="✖ 不能为空";
      return false;
    }else{
      this.pass_f="✔";
      return true;
    }
  }
  isEnsurenewpass(){//新密码确认
    if(this.renewpass_f==null){
      this.repass_f="✖ 不能为空";
      return false;
    }else if(this.renewpass_f!=this.newpass_f){
      this.repass_f="✖ 密码不一致";
      return false;
    }else{
      this.repass_f="✔";
      return true;
    }
  }
  //发送邮箱验证码
  getMailtoken(){
    if(this.mailclick!="点击发送验证码"){
    }else{
      var $this = this;
      $this.options = new ResponseOptions({headers:$this.headers});
      if($this.username_f==null||$this.username_f==""||$this.username_f==undefined){
        $this.name_f="✖ 不能为空"
      }else{
        $this.mailclick = "正在发送验证码"
        var json = {"email":$this.tokenmail_f,"username":$this.username_f};
        $this.http.post($this.httpget.vcode(),JSON.stringify(json),$this.options).subscribe(function (res) {
          if(res.json().code==2001){
            if(res.json().data==1){
              $this.mailclick = "验证码发送成功";
            }
          }else{
            $this.mailclick = "验证码发送失败";
          }
        });
      }
    }
  }
  /********/
  getTruemes(){
    return(
      this.isUsername()&&
        this.isNewpass()&&
        this.sendEmail()&&
        this.isEnsurenewpass()&&
        this.isTokencode()
    );
  }
  //确认修改
  ensureAlter(){
   if(this.getTruemes()==true){
     var $this = this;
     $this.is_alterok = true;
     $this.options = new ResponseOptions({headers:$this.headers});
     var json = {"vcode":$this.tokencode_f,"username":$this.username_f,"password":$this.newpass_f};
     $this.http.post($this.httpget.changepass(),JSON.stringify(json),$this.options).subscribe(function (res) {
       console.log(res.json());
       if(res.json().code==2001){
          $this.ischange ="修改成功";
          $this.ischange="密码修改成功，新密码："+$this.newpass_f;
          setTimeout(function () {
             $this.is_alterok = false;
             $this.is_mail = false;
             $this.rebackLogin();
          },3000);
        }else {
         $this.ischange =res.json().message;
        }
     });
   }
  }
  /****/
  loginSys(){
    var $ = this;
    var namestr = $.username.replace(/(^\s*)|(\s*$)/g, '');//去除空格;
    var passtr = $.userpass.replace(/(^\s*)|(\s*$)/g, '');//去除空格;
    if (namestr == '' || namestr == undefined || namestr == null) {
      $.name="✖ 不能为空";
      $.is_name =false;
    } else {
      // $.name="✔ ";
      $.is_name =true;
    }
    if (passtr == '' || passtr == undefined || passtr == null) {
      $.pass="✖ 不能为空";
      $.is_pass=false;
    } else {
      // $.pass="✔ ";
      $.is_pass=true;
    }
    if($.is_name ==true&&$.is_pass==true){
      $.is_clogin=1;
      var json = {"username":this.username,"password":this.userpass};
      $.login.emit(JSON.stringify(json));//父组件传参
    }
  }
}



// WEBPACK FOOTER //
// ./src/mainpage/login/login.component.ts